import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import './styles/StudentsPage.css';
import { FaEye, FaEdit } from 'react-icons/fa';
import moment from 'moment';

const ClassPublicListPage = () => {
    const [branchList, setBranchList] = useState([]);
    const [students, setStudents] = useState([]);
    const [programList, setProgramList] = useState([]);
    const [searchName, setSearchName] = useState('');
    const [program, setProgram] = useState('');
    const [selectedBranch, setSelectedBranch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalData, setTotalData] = useState(0); 
    const [classDate, setClassDate] = useState('');
    const navigate = useNavigate();
    const [isSearched, setIsSearched] = useState(false);

    // Fetch branch list when component mounts
    useEffect(() => {
        const fetchBranchList = async () => {
            try {
                const response = await api.get('/utils/getBranchList');
                const branches = response.data.data.branchList.map(branch => ({
                    id: branch.branch_id,
                    name: `${branch.branch_code} - ${branch.branch_name}`,
                }));
                setBranchList(branches);
            } catch (error) {
                console.error("Failed to fetch branch list", error);
            }
        };
        fetchBranchList();

        api.get('/utils/getProgramClassList')
        .then(response => setProgramList(response.data.data.programList))
        .catch(error => console.error('Error fetching program list:', error));
        
    }, []);

    useEffect(() => {
        if (isSearched) {
            handleSearch(); // Fetch students when currentPage changes
        }
    }, [currentPage, isSearched]);

    // Fetch students based on filter when search is clicked
    const handleSearch = async () => {
        try {
            const response = await api.post('/student/class/public/list', {
                data: [{
                    student_name: searchName,
                    branch_id: selectedBranch,
                    classDate: classDate,
                    program_id: program
                }],
                limit: 25, // Membatasi data per halaman menjadi 25
                page: currentPage // Mengirim halaman saat ini ke backend
            });
            setStudents(response.data.data.studentList);
            setTotalData(response.data.data.totalCount); // Total data tanpa pagination
            setTotalPages(Math.ceil(response.data.data.totalCount / 25)); // Menghitung total halaman berdasarkan total data


            const totalCount = response.data.data.totalCount;
            //alert(totalCount);
            if (totalCount > 0) {
               // alert("masuk1 ");
                setTotalPages(Math.ceil(totalCount / 25));
                //alert(totalPages);
                //alert(currentPage);
                if(totalPages < currentPage){
                    //alert("masuk2 ");
                    setCurrentPage(1);
                }
            } else {
                setCurrentPage(1);
                setTotalPages(1);
            }

            setIsSearched(true);
        } catch (error) {
            console.error("Failed to fetch students", error);
        }
    };
    

    // Handle pagination
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const handleViewDetails = (studentId) => {
        navigate(`/student/class/detail/${studentId}`);
    };


    return (
        <div className="students-page">
            <div className="page-title">Kidola Public Student Class List</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Nama Siswa</label>
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Enter student name"
                                            value={searchName}
                                            onChange={(e) => setSearchName(e.target.value)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Program Class</label>
                                    </td>
                                    <td>
                                        <select value={program} onChange={(e) => setProgram(e.target.value)}>
                                            <option value="">Select Program</option>
                                            {programList.map(program => (
                                                <option key={program.program_id} value={program.program_id}>
                                                    {program.program_name} - {program.Costs[0].cost_item}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Cabang</label>
                                    </td>
                                    <td>
                                        <select
                                            value={selectedBranch}
                                            onChange={(e) => setSelectedBranch(e.target.value)}
                                        >
                                            <option value="">Select Branch</option>
                                            {branchList.map(branch => (
                                                <option key={branch.id} value={branch.id}>
                                                    {branch.name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Class Month</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="month"
                                            name="classDate"
                                            value={classDate} 
                                            onChange={e => setClassDate(e.target.value)}
                                        />
                                    </td>  
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <button onClick={handleSearch}>Search</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="section">
                    <div className="students-list">
                        <table>
                            <thead>
                                <tr>
                                    <th class="no-column">No</th>
                                    <th>Student Name</th>
                                    <th>Branch</th>
                                    <th>Program Class</th>
                                    <th>Class Month</th>
                                    {/*
                                    <th>Actions</th>
                                    */}
                                </tr>
                            </thead>
                            <tbody>
                                {students.map((student, index) => (
                                    <tr key={student.PublicStudent.public_student_id}>
                                        <td class="no-column">{index + 1 + (currentPage - 1) * 25}</td>
                                        <td>{student.PublicStudent.student_name}</td>
                                        <td>{student.PublicStudent.Branch.branch_name}</td>
                                        <td>{student.Program.program_name} - {student.Program.Costs[0].cost_item}</td>
                                        <td>{moment().month(student.class_month - 1).year(student.class_year).format('MMMM YYYY')}</td>
                                        {/*
                                        <td>
                                            <FaEye className="action-icon" title="View Details" onClick={() => handleViewDetails(student.PublicStudent.public_student_id)} />
                                        </td>
                                        */}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="total-data">
                        <span>Total Data: {totalData}</span>
                    </div>
                    <div className="pagination">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <button onClick={handlePrevPage} disabled={currentPage === 1}>
                                            Prev
                                        </button>
                                    </td>
                                    <td>
                                        <span>Page {currentPage} of {totalPages}</span>
                                    </td>
                                    <td>
                                        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                                            Next
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClassPublicListPage;
